export const R_RECOMMENDATIONS = 1
export const R_INSTITUTIONS = 2
export const R_USERS = 3
export const R_COMPETENT_AUTHORITIES = 5

